const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
//@ Commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @actions
const cardChargeActions = require('actions/cardCharge');

// @components
const CardCharge = require('components/cards/cardCharge/cardCharge');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const CardChargeSuccessStep = require('components/cards/cardChargeSteps/cardChargeSuccessStep/cardChargeSuccessStep');
const CardChargeErrorStep = require('components/cards/cardChargeSteps/cardChargeErrorStep/cardChargeErrorStep');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const InactiveAccountsError = require('components/commons/inactiveAccountsError/inactiveAccountsError');

// @utilities
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');

// @constants
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');
const { WEB_INACTIVE_ACCOUNT_ENABLED } = require('constants/flagBasedFeatures');

class CardChargeView extends React.Component {
    componentDidMount() {
        const { match: { params: { cardId } }, requestECardInfo, history, immCards, immAccounts, setAllAccountsToInactive } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_CHARGE, { immCard }, history);
        requestECardInfo(cardId);

        const tagging = immCard.get('tagging');
        recordPath('tarjeta/carga-saldo', PAGE_GENERIC, '', '', tagging);

        const allAccountsInactive = hasAllAccountsInactive(immAccounts.get('byOrder').toJS(), immAccounts.get('byId'));
        if (allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    render() {
        const {
            match: { params: { cardId } },
            immCards,
            immCardCharge,
            immFlagBasedFeatures,
            validateStep,
            setAllAccountsToInactive,
            setVisibleStep,
            setWillCancel,
            postChange,
            immAccounts,
            requestECardInfo
        } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const isPeriodicTransfer = immFlagBasedFeatures.get('hb-card-periodic-trfr-enabled');
        const isInactiveAccountsEnabled = immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED);
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-cardsEcardTitle')}
            />
        );

        const type = immCard.get('type');
        const subtitleLeft = formatText(`cards-${type}`);
        const subtitleRight = immCard.get('alias').get('current');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: immCard ? immCard.get('alias').get('current') : '',
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('cardCharge-title')
            }
        ];
        let bodyContent;

        if (immCardCharge.get('submitSuccessful')) {
            bodyContent = (
                <CardChargeSuccessStep
                    immCard={immCard}
                    immCardCharge={immCardCharge}
                    loading={immCardCharge.get('isFetching')}
                    requestEcardInfo={requestECardInfo}
                    immAccounts={immAccounts}
                />
            );
        } else if (immCardCharge.get('blockFlow')) {
            bodyContent = <CardChargeErrorStep immCard={immCard} />;
        } else if (immCardCharge.get('allAccountsInactive')) {
            bodyContent = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <InactiveAccountsError
                        navigateToBackButtonText={'cards'}
                        navigateToBackButtonURL={'cards'}
                    />
                </div>
            );
        } else {
            bodyContent = (
                <div>
                    <div className="col-xs-12 col-md-8">
                        <CardCharge
                            immAccounts={immAccounts}
                            immCard={immCard}
                            immCardCharge={immCardCharge}
                            isInactiveAccountsEnabled={isInactiveAccountsEnabled}
                            validateStep={validateStep}
                            setVisibleStep={setVisibleStep}
                            setWillCancel={setWillCancel}
                            postChange={postChange}
                            isPeriodicTransfer={isPeriodicTransfer}
                            setAllAccountsToInactive={setAllAccountsToInactive}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 grid-view--variable-cell-separation">
                        <CardDetailsSidebar immCard={immCard} />
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className="container-fluid card-charge-view--header-identifier">
                    <div className="row">
                        <OKCover size="medium" section="cards" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                subtitleLeft={subtitleLeft}
                                subtitleRight={subtitleRight}
                                tutorial={tutorial}
                                finalTitle={getFinalTitle('cardCharge-title')}>
                                <CardHeaderDetails
                                    immCard={immCard}
                                    isFetching={immCardCharge.get('isFetching')}
                                />
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {bodyContent}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CardChargeView.propTypes = {
    clearRequest: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCardCharge: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    postChange: PropTypes.func.isRequired,
    requestECardInfo: PropTypes.func.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired
};

module.exports.constructor = CardChargeView;
module.exports.CardChargeView = connect(
    state => ({
        immAccounts: state.accounts,
        immCards: state.cards,
        immCardCharge: state.cardCharge,
        immFlagBasedFeatures: state.flagBasedFeatures
    }),
    {
        validateStep: cardChargeActions.validateStep,
        setAllAccountsToInactive: cardChargeActions.setAllAccountsToInactive,
        setVisibleStep: cardChargeActions.setVisibleStep,
        setWillCancel: cardChargeActions.setWillCancel,
        postChange: cardChargeActions.postChange,
        clearRequest: cardChargeActions.clearRequest,
        requestECardInfo: cardChargeActions.requestECardInfo
    }
)(withRouter(CardChargeView));
